import { render, staticRenderFns } from "./PrescriptionPresetForm.vue?vue&type=template&id=58682c24&scoped=true"
import script from "./PrescriptionPresetForm.vue?vue&type=script&lang=js"
export * from "./PrescriptionPresetForm.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionPresetForm.vue?vue&type=style&index=0&id=58682c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58682c24",
  null
  
)

export default component.exports